'use client'

import useSWR from 'swr'

import { CollateralResponse } from '../utils/edge/collateral-handler'

interface UseBackingAssets {
  isLoading: boolean
  totalBackingAssetsInUsd: number | undefined
}

export const useBackingAssets = (): UseBackingAssets => {
  const { data, isLoading } = useSWR<CollateralResponse>('/api/positions/current/collateral?latest=true')

  return { isLoading, totalBackingAssetsInUsd: data?.totalBackingAssetsInUsd } as UseBackingAssets
}
